import router from "@/router";
import { ElMessage } from "element-plus";
import Cookies from 'js-cookie';
class AccountApi {
  static toLogin = (): void => {
    localStorage.removeItem("access_token")
    localStorage.removeItem("refresh_token")
    localStorage.removeItem("marketList")
    localStorage.removeItem("projectoften")
    localStorage.removeItem("roleSound")
     //   清除cookie
    Cookies.remove('refreshToken', { domain: '.123vp.com', path: '/' });
    Cookies.remove('accessToken', { domain: '.123vp.com', path: '/' });
    router.push({ path: '/' ,query: {}} ).catch(() => {
      ElMessage.error("无法跳转到登录界面");
    });
  };
}
export default AccountApi;
